module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-swipe-welf",
    class: [_vm.transition ? 'fullpage-item-transition' : '']
  }, [_c('div', {
    staticClass: "fullpage-item"
  }, [_c('c-page', {
    staticStyle: {
      "background-color": "transparent"
    }
  }, [_c('c-content', [_c('template', {
    slot: "noscroll"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card_a"
  }, [_c('img', {
    staticClass: "card_touchimg",
    attrs: {
      "src": _vm.infoList[0].image
    }
  })])]), _vm._v(" "), _c('c-button', {
    staticClass: "lookMore",
    nativeOn: {
      "click": function($event) {
        _vm.jumpTo(_vm.infoList[0].codelink.url)
      }
    }
  }, [_vm._v("\n            查看更多\n          ")])], 1)], 2)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3841812c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-swipe-welf/index.vue
// module id = 1034
// module chunks = 2